import { render, staticRenderFns } from "./ProductDetailDeskLoader.vue?vue&type=template&id=1ca398d2&"
import script from "./ProductDetailDeskLoader.vue?vue&type=script&lang=js&"
export * from "./ProductDetailDeskLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports